import React from "react";
import { Modal } from "react-bootstrap";

const VerificationDialog = ({ show, original, verified, onSelect }) => {
  // Helper to display address lines
  const renderAddressDisplay = (address) => {
    if (!address) return null;
    const lines = [
      address.address1,
      address.address2,
      `${address.city || ""}${address.state ? ", " + address.state : ""}${
        address.zipcode ? " " + address.zipcode : ""
      }`,
      address.country,
    ].filter(Boolean);
    return (
      <div>
        {lines.map((line, idx) => (
          <div key={idx}>{line}</div>
        ))}
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={() => {}} // prevent close by backdrop
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="modal-header bg-success py-2">
        <Modal.Title>
          <h5 className="modal-title text-uppercase text-white mt-0">
            <i className="fas fa-check-circle mr-2"></i> Address Verified
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          We've verified your address and found that the Smarty verified address
          contains some overlapping address information. To help avoid duplicate
          address information, please choose which version you'd like to keep.
        </p>

        <div className="row">
          {/* Original Address */}
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-header bg-light">
                <strong>
                  <i className="fas fa-user-edit mr-2"></i> My Original
                </strong>
              </div>
              <div className="card-body">{renderAddressDisplay(original)}</div>
            </div>
          </div>

          {/* Verified Address */}
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-header bg-light">
                <strong>
                  <i className="fas fa-check mr-2"></i> Verified (Smarty)
                </strong>
              </div>
              <div className="card-body">{renderAddressDisplay(verified)}</div>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button
            className="btn btn-outline-success mr-2"
            onClick={() => onSelect(false)}
          >
            Keep My Original
          </button>
          <button
            className="btn btn-outline-success"
            onClick={() => onSelect(true)}
          >
            Use Verified Address
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerificationDialog;
